export default __webpack_public_path__ + "static/2-62ed0f16a931f9f540866f4d768c62d7.jpeg";